export default __webpack_public_path__ + "static/media/audio-icon.0b177c36.svg";